import { Grid, LinearProgress, Typography } from '@material-ui/core'
import { withTranslation, WithTranslation } from 'react-i18next'
import { reduxForm } from 'redux-form'
import SubmitFormButton from '../../../../components/Buttons/SubmitFormButton'
import { ReduxFormField } from '../../../../components/FormInput/ReduxWrappers'
import { MuiClasses } from '../../../../types'
import { ReduxForm } from '../../../../types/forms'
import { validateEmail, required } from '../../../../utils/validation/forms'

interface RequestPasswordResetFormProps extends WithTranslation, ReduxForm {
  sendResetCode: (arg: any) => any
  classes: MuiClasses
}

const RequestPasswordResetForm = ({
  sendResetCode,
  t,
  handleSubmit,
  submitting,
  error
}: RequestPasswordResetFormProps) => (
  <form onSubmit={handleSubmit(sendResetCode)}>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant='body2' gutterBottom>
          {t('forgotPassword.explanation')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <ReduxFormField
          name='email'
          label={t('person.email')}
          validate={[required, validateEmail]}
          autoComplete='username'
          required
        />
      </Grid>
      <Grid item xs={12}>
        <SubmitFormButton
          submitting={submitting}
          label='forgotPassword.requestCode'
        />
      </Grid>
      {submitting && <LinearProgress />}
      {error && (
        <Typography style={{ color: 'red' }} variant='body1'>
          {error}
        </Typography>
      )}
    </Grid>
  </form>
)

export default reduxForm({
  form: 'RequestPasswordResetForm'
})(withTranslation()(RequestPasswordResetForm as any) as any) as any
